import { Currency } from '@/core/currency/interfaces';

const CDF: Currency = {
    name: 'Congolese Franc',
    demonym: 'Congolese',
    majorSingle: 'Franc',
    majorPlural: 'Francs',
    codeNumeric: '976',
    symbol: 'FC',
    symbolNative: '₣',
    minorSingle: 'Centime',
    minorPlural: 'Centimes',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'CDF',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default CDF;
